import PropTypes from 'prop-types'

import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

const OrderBundleDetails = (props) => {
  const { orderBundleFormPayload } = props || {}

  const {
    entityState: {
      end_date,
      price,
      product_code,
      product_name,
      start_date,
      title,
    },
    errors,
    handlers,
  } = orderBundleFormPayload

  return (
    <DashboardModule title="Order Bundle Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.title} label="Title">
            <input
              name="title"
              value={title}
              type="text"
              {...handlers}
            />
          </Form.Field>

          <Form.Field errorMessage={errors.price} label="Display Price" marginTop={['large', 0]}>
            <input
              min="0"
              name="price"
              value={price}
              type="number"
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="External Code Title">
            <input
              name="product_name"
              value={product_name}
              type="text"
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="External ID Code" marginTop={['large', 0]}>
            <input
              name="product_code"
              value={product_code}
              type="text"
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row marginTop="large">
          <Form.Field label="Start Date">
            <input
              name="start_date"
              type="date"
              value={start_date}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="End Date" marginTop={['large', 0]}>
            <input
              name="end_date"
              type="date"
              min={start_date}
              value={end_date}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

OrderBundleDetails.propTypes = {
  orderBundleFormPayload: PropTypes.shape({
    entityState: PropTypes.object.isRequired,
    errors: PropTypes.object,
    handlers: PropTypes.object.isRequired,
  }).isRequired,
}

export default OrderBundleDetails
